import { useTheme } from '@emotion/react'
import { useStaticQuery, graphql } from 'gatsby'
import { Container, SectionTitle, Section } from 'chaoskit/src/components'

import ActionCard from '~components/ActionCard'
import Data from '~components/Data'

const StaticFeaturedArticles = (props) => {
  const theme = useTheme()

  const {
    staticPagesConfig: {
      childMdx: { frontmatter: staticPagesConfig },
    },
  } = useStaticQuery(graphql`
    query StaticFeaturedArticlesData {
      staticPagesConfig: file(
        name: { eq: "static-pages" }
        absolutePath: { regex: "/src/data/" }
      ) {
        childMdx {
          frontmatter {
            heading
            blurb
            articles {
              title {
                fileAbsolutePath
                frontmatter {
                  title
                }
                fields {
                  featuredImage
                  fullUrl
                }
              }
            }
          }
        }
      }
    }
  `)

  return (
    <Section
      space="large"
      css={{
        background: theme.color.panel.base,
      }}
      {...props}
    >
      <Container>
        <SectionTitle
          title={<Data>{staticPagesConfig.heading}</Data>}
          sub={<Data>{staticPagesConfig.blurb}</Data>}
        />
        <div
          css={{
            display: 'grid',
            gap: theme.space.large,

            [theme.mq.small]: {
              gridTemplateColumns: 'repeat(2, 1fr)',
            },

            [theme.mq.medium]: {
              gridTemplateColumns: 'repeat(3, 1fr)',
            },
          }}
        >
          {staticPagesConfig.articles.map(({ title: node }) => (
            <ActionCard
              key={node.fileAbsolutePath}
              photo={node.fields.featuredImage}
              hover
              photoStretch="contain"
              url={node.fields.fullUrl}
            >
              <Data>{node.frontmatter.title}</Data>
            </ActionCard>
          ))}
        </div>
      </Container>
    </Section>
  )
}

export default StaticFeaturedArticles
